import React, {useContext, useState, useEffect} from 'react';
import { Text, View, Platform, ActivityIndicator } from 'react-native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { CredentialsContext } from '../components/CredentialsContext';
import { useFonts } from 'expo-font'
import { StatusBar } from 'expo-status-bar';

import RoomModules from '../screens/RoomModules';
import BoldStyledText from '../components/BoldStyledText';

const Tab = createMaterialTopTabNavigator();

const MaterialTopTabNav = props =>{

    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);
    // const [storedCredentials, setStoredCredentials] = useContext(CredentialsContext)
    const [appReady, setAppReady] = useState(false);

    useEffect(()=> {
        AsyncStorage.getItem('flowerCribCredentials')
        .then((result)=>{
          if(result !== null){
            setStoredCredentials(JSON.parse(result));
            setAppReady(true)
          } else {
            setStoredCredentials(null);
            setAppReady(true)
          }
          
        })
        .catch(err => console.log(err))

    }, [])

    let [fontsLoaded] = useFonts({
        "Mikhak-Bold": require('../assets/Fonts/Mikhak-Bold.ttf')
    })

    // const [userRooms, setuserRooms] = useState(()=> {
    //     if(typeof storedCredentialsState.userRooms == 'string') return JSON.parse(storedCredentialsState.userRooms)
    //     else return storedCredentialsState.userRooms
    // });
    
    if(!appReady) {
        return (
          <View style={{flex:1, justifyContent: 'center', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#3b3c37'}}>
            <StatusBar />
            <ActivityIndicator size='large' color={storedCredentials.theme == 'light' ? 'blue' : '#e88804'} />
          </View>
        ) 
    }
    
    return (
        <Tab.Navigator 
            backBehavior='none'
            independent={true}
            screenOptions={({ route }) => ({
                tabBarStyle: { backgroundColor: storedCredentials.theme == 'light' ? '#f2f2f2' :  '#3b3c37' },
                tabBarIndicatorStyle:{ backgroundColor: storedCredentials.theme == 'light' ? '#f2f2f2' :  '#3b3c37' },
                tabBarItemStyle:{width: 160},
                tabBarScrollEnabled: true,
                // animationEnabled: false,
                lazy: true,
                lazyPlaceholder: () => {
                    return(
                        <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? '#f2f2f2' : '#3b3c37' }}>
                            <BoldStyledText style={{color: storedCredentials.theme == 'light' ? 'blue' : '#e88804', fontSize: 20}}> درحال بارگذاری... </BoldStyledText>
                        </View>
                )},
                tabBarLabel: ({ focused }) => {
                return (
                    <View style={{ alignItems: 'center' }}>
                        {focused ? 
                            <BoldStyledText style={{ fontSize: 20 , color: storedCredentials.theme == 'light' ? 'blue' : '#e88804' }}>
                                {route.name}
                            </BoldStyledText>
                        :
                            <BoldStyledText style={{ fontSize: 20 , color: storedCredentials.theme == 'light' ? 'black' : 'white'}}>
                                {route.name}
                            </BoldStyledText>

                        }
                    </View>
                );
                },
                animationEnabled: false,
            })}
            initialRouteName={props.route.params.itemData.item.name}
            swipeVelocityImpact={10}
        >
            {/* {(prop) => ModulesScreen(prop)} */}
            {storedCredentials.userRooms.map(room => 
                <Tab.Screen 
                    name={room.name} 
                    key={room.id}
                    options={{
                        animationEnabled: false,
                    }}
                > 
                    {prop => <RoomModules roomData={room} rootStackProps={props} navProps={prop} rooms={storedCredentials.userRooms} />}  
                </Tab.Screen>
            )}
        </Tab.Navigator>  
    )
};

let LightStyles = {
    wrapper:{
        justifyContent:'center',
        flex: 1
    },
    plugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedPlugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    acCard:{
        justifyContent: 'center',
        height: 225,
        backgroundColor: '#88b388',
        
    },
    loadedACCard:{
        justifyContent: 'center',
        height: 225,
        backgroundColor: '#c2ffc2',
    },
    acView:{
        flexDirection: 'row-reverse', flex: 1,justifyContent: 'space-between'
    },
    loadedAcView: {
        flexDirection: 'row-reverse', flex: 1,justifyContent: 'space-between', alignItems: 'flex-end'
    },
    s3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedS3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    s4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedS4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'black'
    },
    addModuleCard:{
        backgroundColor: '#ffffff',
        height: 30,
        alignItems:'center',
        justifyContent:'center'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '5%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 50,
        tintColor: 'black',
    },
    addModuleModalHeader:{
        flexDirection: 'row-reverse',
        paddingVertical: 15,
        backgroundColor: '#344a47',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center'
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    addModuleModalBody:{
        padding: 20,
    },
    addModuleModalDescriptions:{
        fontSize: 22,
        fontWeight: '400',
        margin: 5,
        textAlign: 'right',
    },
    UssidandPassTextInputs:{
        backgroundColor: '#F5F6FA',
        padding: 10,
        marginHorizontal: 20,
        marginVertical: 10,
        textAlign: 'center',
        borderWidth: 1,
        borderRadius: 20,
        fontSize: 22,
        fontWeight: '300'
    },
    addModuleModalSubmitBtn:{
        backgroundColor: '#dab2be',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },
    addModuleModalSubmitBtnText:{
        color: 'white',
        fontSize: 30,
        fontWeight: '600'
    },
    addModuleModalDescriptionsUSSIDandPassInputsWrapper:{
        margin: 20,
        marginBottom: 50
    },
    lottie: {
        width: 100,
        height: 100
    }
};
export default MaterialTopTabNav;